module.exports = __webpack_public_path__ + "static/media/SH 26_ADDON.b0cba9a9.mp3";